import Page from 'src/components/page/page';
import useFaqDetails from './faq-details.hook';
import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import FaqForm from './components/faq-form';

export default function FaqDetails() {
  const hook = useFaqDetails();
  return (
    <Page title={hook.isEdit ? 'Editar Pergunta' : 'Cadastrar Pergunta'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={hook.isEdit ? 'Editar Pergunta' : 'Cadastrar Pergunta'}
          links={[]}
        />
        {hook.isLoadingFaqDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <FaqForm hook={hook} />
        )}
      </Container>
    </Page>
  );
}
